import { SubscriptionListResponse } from '../subscription';

export function fromServerToSubscription(
  response: any,
): SubscriptionListResponse {
  const subscriptionItems = response.subscription?.subscription_items || [];
  const planSubscriptionItem = subscriptionItems.find(
    (item: any) => item.item_type === 'plan',
  );

  return {
    customer: response.customer,
    subscription: {
      plan: {
        item_price_id: planSubscriptionItem?.item_price_id || '',
        amount: planSubscriptionItem?.amount || 0,
        free_quantity: planSubscriptionItem?.free_quantity || 0,
        trial_end: planSubscriptionItem?.trial_end || 0,
        unit_price: planSubscriptionItem?.unit_price || 0,
        quantity: planSubscriptionItem?.quantity || 0,
      },
      ...response.subscription,
    },
  };
}

/**
 * @deprecated
 * @param response
 * @returns
 */
export function fromServerToSubscriptionLegacy(
  response: any,
): SubscriptionListResponse {
  const subscription = response?.subscription || {};
  return {
    ...response,
    subscription: {
      plan: {
        item_price_id: subscription.plan_id || '',
        amount: subscription.plan_amount || 0,
        free_quantity: subscription.plan_free_quantity || 0,
        trial_end: subscription.plan_trial_end || 0,
        unit_price: subscription.plan_unit_price || 0,
        quantity: subscription.plan_quantity || 0,
      },
      ...subscription,
    },
  };
}
